import React from 'react';
import i18n from '@/utils/i18n';
import {
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface ModalProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  header: string;
  body: React.ReactNode;
  acceptButtonText: string;
  acceptButtonIcon: React.ReactNode;
  acceptButtonAction: () => void;
  acceptButtonDisabled: boolean;
  showCancelButton?: boolean;
  size?: string;
  className?: string;
}

export const CustomModal: React.FC<ModalProps> = ({
  isOpen,
  setIsOpen,
  header,
  body,
  acceptButtonText,
  acceptButtonIcon,
  acceptButtonAction,
  acceptButtonDisabled,
  showCancelButton = true,
  className,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent
        className={cn('tw:max-h-[96vh] tw:overflow-y-auto', className)}
      >
        <DialogHeader>
          <DialogTitle>{header}</DialogTitle>
        </DialogHeader>
        <DialogBody>{body}</DialogBody>
        <DialogFooter>
          {showCancelButton && (
            <DialogClose asChild>
              <Button variant="secondary">{i18n.t('Common:cancel')}</Button>
            </DialogClose>
          )}
          <Button onClick={acceptButtonAction} disabled={acceptButtonDisabled}>
            {acceptButtonIcon} {acceptButtonText}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
